//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
import "../Motion/Motion.AdamsSolverProperty.js";
import "../no/Expression.js";
import "../Motion/Motion.RecurdynSolverProperty.js";
import "../no/Expression.js";
let d=[[[0,"AdamsSolverProperty",1,"Motion.AdamsSolverProperty",0],[0,"AnalysisType",1,0],[0,"Description",1,0],[1,"GravityValueExpression",0,"Expression",0],[0,"GravityVector",1,"Direction",0],[0,"IsSkipStep",1,0],[0,"Name",1,0],[0,"RecurdynSolverProperty",1,"Motion.RecurdynSolverProperty",0],[0,"SkipSteps",1,0],[0,"SolutionType",1,0],[0,"StaticAnalysis",1,0],[0,"Step",1,0],[1,"TimeExpression",0,"Expression",0]],[],[]];
SPLM.Motion.MotionSolutionBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.MotionSolutionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.MotionSolutionBuilder.SolutionTypes = Object.freeze({
    "Normal" : "Normal", "Articulation" : "Articulation", "Spreadsheet" : "Spreadsheet", "Flexbody" : "Flexbody"});

SPLM.Motion.MotionSolutionBuilder.AnalysisTypes = Object.freeze({
    "Dynamic" : "Dynamic", "Static" : "Static", "Control" : "Control"});

SPLM.Motion.MotionSolutionBuilder.Objective = Object.freeze({
    "IntegratedSolve" : "IntegratedSolve", "ExportToExternalPlatform" : "ExportToExternalPlatform"});

SPLM.Motion.MotionSolutionBuilder.Platform = Object.freeze({
    "Amesim" : "Amesim", "Simulink" : "Simulink", "Fmi" : "Fmi", "Procyon" : "Procyon", "Concurrent" : "Concurrent", "Dspace" : "Dspace", "Scalexio" : "Scalexio"});

SPLM.Motion.MotionSolutionBuilder.WorkingDirectoryType = Object.freeze({
    "SimFolder" : "SimFolder", "UserDefined" : "UserDefined"});

SPLM.Motion.MotionSolutionBuilder.GravityOption = Object.freeze({
    "NoGravity" : "NoGravity", "EarthGravity" : "EarthGravity", "UserDefinedComponent" : "UserDefinedComponent", "UserDefinedVector" : "UserDefinedVector"});

SPLM.Motion.MotionSolutionBuilder.GravityValueOption = Object.freeze({
    "Expression" : "Expression", "Profile2d" : "Profile2d"});

SPLM.Motion.MotionSolutionBuilder.StepTypeOption = Object.freeze({
    "NumSteps" : "NumSteps", "StepSize" : "StepSize", "PrintIntervalCurve" : "PrintIntervalCurve", "SpeedSweepDriver" : "SpeedSweepDriver"});

SPLM.Motion.MotionSolutionBuilder.UnitLength = Object.freeze({
    "Millimeter" : "Millimeter", "Centimeter" : "Centimeter", "Meter" : "Meter", "Inch" : "Inch", "Foot" : "Foot", "Micrometer" : "Micrometer"});

SPLM.Motion.MotionSolutionBuilder.UnitMass = Object.freeze({
    "Gram" : "Gram", "Kilogram" : "Kilogram", "MetricTonne" : "MetricTonne", "Slinch" : "Slinch", "Slug" : "Slug", "Milligram" : "Milligram"});

SPLM.Motion.MotionSolutionBuilder.UnitForce = Object.freeze({
    "Micronewton" : "Micronewton", "Newton" : "Newton", "KilogramForce" : "KilogramForce", "Pound" : "Pound", "Dyne" : "Dyne"});

SPLM.Motion.MotionSolutionBuilder.OutputType = Object.freeze({
    "Binary" : "Binary", "Ascii" : "Ascii", "AsciiAndBinary" : "AsciiAndBinary", "RestartAndBinary" : "RestartAndBinary", "RestartAndAscii" : "RestartAndAscii", "Restart" : "Restart", "All" : "All", "None" : "None", "BinaryAfterRun" : "BinaryAfterRun"});

SPLM.Motion.MotionSolutionBuilder.PrintMethod = Object.freeze({
    "Actual" : "Actual", "Interpolated" : "Interpolated"});

SPLM.Motion.MotionSolutionBuilder.KinematicMethod = Object.freeze({
    "SingleStep" : "SingleStep", "MultiStep" : "MultiStep"});

SPLM.Motion.MotionSolutionBuilder.InverseDynamicMethod = Object.freeze({
    "SingleStep" : "SingleStep", "MultiStep" : "MultiStep"});

SPLM.Motion.MotionSolutionBuilder.AssemblingMethod = Object.freeze({
    "OneStage" : "OneStage", "TwoStages" : "TwoStages"});

SPLM.Motion.MotionSolutionBuilder.RedundancyCheck = Object.freeze({
    "Yes" : "Yes", "No" : "No", "FullPivoting" : "FullPivoting"});

SPLM.Motion.MotionSolutionBuilder.RedundantConstraintCheck = Object.freeze({
    "EveryTimeStep" : "EveryTimeStep", "BeginningOfSimulation" : "BeginningOfSimulation"});

SPLM.Motion.MotionSolutionBuilder.MatrixScaling = Object.freeze({
    "Standard" : "Standard", "Iterative" : "Iterative"});

SPLM.Motion.MotionSolutionBuilder.StaticSolverType = Object.freeze({
    "Harwell" : "Harwell", "QrFull" : "QrFull"});

SPLM.Motion.MotionSolutionBuilder.StaticJacobianType = Object.freeze({
    "Finite" : "Finite", "Exact" : "Exact"});

SPLM.Motion.MotionSolutionBuilder.DynamicIntegrationMethod = Object.freeze({
    "Bdf" : "Bdf", "Pece" : "Pece", "Rbdf" : "Rbdf"});

SPLM.Motion.MotionSolutionBuilder.DynamicSimulationType = Object.freeze({
    "CoSimulation" : "CoSimulation", "ModelExchange" : "ModelExchange"});

SPLM.Motion.MotionSolutionBuilder.DynamicSolverAcceleration = Object.freeze({
    "Banded" : "Banded", "Harwell" : "Harwell", "Iterative" : "Iterative"});

SPLM.Motion.MotionSolutionBuilder.DynamicInitialVelocityMethod = Object.freeze({
    "Qr" : "Qr", "MoorePenrosePseudoInverse" : "MoorePenrosePseudoInverse", "MinimumKineticEnergy" : "MinimumKineticEnergy"});

SPLM.Motion.MotionSolutionBuilder.ConstraintsOptimizationExcludeType = Object.freeze({
    "None" : "None", "Select" : "Select"});

SPLM.Motion.MotionSolutionBuilder.TimeSeriesFileNameFormat = Object.freeze({
    "OutputName" : "OutputName", "ResultOutputName" : "ResultOutputName"});

SPLM.Motion.MotionSolutionBuilder.VehicleRoadHeightAdjustment = Object.freeze({
    "None" : "None", "Road" : "Road", "Vehicle" : "Vehicle"});

SPLM.Motion.MotionSolutionBuilder.RealTimeSystemType = Object.freeze({
    "Windows" : "Windows", "Linux" : "Linux"});

SPLM.Motion.MotionSolutionBuilder.StaticSuspensionType = Object.freeze({
    "Dependent" : "Dependent", "Independent" : "Independent"});

SPLM.Motion.MotionSolutionBuilder.MotionSolverType = Object.freeze({
    "Classic" : "Classic", "NextGeneration" : "NextGeneration"});

SPLM.Motion.MotionSolutionBuilder.NextGenSolverEvaluationUpdate = Object.freeze({
    "Continuous" : "Continuous", "Delayed" : "Delayed"});

SPLM.Motion.MotionSolutionBuilder.NextGenSolverMultiprocessorMode = Object.freeze({
    "Serial" : "Serial", "Threaded" : "Threaded", "SpecifiedThreads" : "SpecifiedThreads"});

export default SPLM;